/**
 * Business categories supported by the Central Admin Console.
 * The console is category-agnostic at its foundation; Pharmacy is simply the
 * first category with an implemented management module.
 */
export const BUSINESS_CATEGORY_CODES = ['PHARMACY', 'SUPERMARKET', 'RESTAURANT', 'OTHER'];
export const BUSINESS_CATEGORIES = [
    {
        code: 'PHARMACY',
        slug: 'pharmacies',
        name: 'Pharmacies',
        singular: 'Pharmacy',
        description: 'Pharmacy customers, installations and licenses',
        moduleAvailable: true,
    },
    {
        code: 'SUPERMARKET',
        slug: 'supermarkets',
        name: 'Supermarkets',
        singular: 'Supermarket',
        description: 'Retail and grocery store customers',
        moduleAvailable: true,
    },
    {
        code: 'RESTAURANT',
        slug: 'restaurants',
        name: 'Restaurants',
        singular: 'Restaurant',
        description: 'Restaurant and café customers',
        moduleAvailable: false,
    },
    {
        code: 'OTHER',
        slug: 'other',
        name: 'Other Businesses',
        singular: 'Business',
        description: 'Customers in other business sectors',
        moduleAvailable: false,
    },
];
export function getCategoryBySlug(slug) {
    return BUSINESS_CATEGORIES.find((c) => c.slug === slug);
}
export function getCategoryByCode(code) {
    const found = BUSINESS_CATEGORIES.find((c) => c.code === code);
    if (!found)
        throw new Error(`Unknown business category: ${code}`);
    return found;
}
//# sourceMappingURL=categories.js.map